import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const LineItemGroup = observer(({ label, labelError, children, onLabelChangeCallback, onRemoveCallback }) => (
  <div className="line-item-group">
    <div className="row">
      <span>
        <input
          type="text"
          className={`group-label${labelError ? " error" : ""}`}
          placeholder="list name"
          value={label}
          onChange={event => onLabelChangeCallback(event.target.value)}
        />
      </span>
      <span className="spacer" />
      &nbsp; &nbsp; &nbsp;
      <a
        href="#"
        onClick={event => {
          event.preventDefault();
          onRemoveCallback();
        }}
      >
        <i className="delete icon" style={{ textDecoration: "none" }} />
        delete entire list
      </a>
    </div>
    <div className="row line-items">{children}</div>
  </div>
));

LineItemGroup.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
  labelError: PropTypes.bool,
  onLabelChangeCallback: PropTypes.func.isRequired,
  onRemoveCallback: PropTypes.func.isRequired,
};

export default LineItemGroup;
